import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function InformationIcon({ focused, height, width }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${(height || 33) * Screen.widthRatio}`}
      height={`${width || 32 * Screen.widthRatio}`}
      viewBox={'0 0 33 32'}
    >
      <path
        d='M16 3.11532e-06C24.8366 2.72906e-06 32 7.16345 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 -3.13124e-07 24.8366 -6.99382e-07 16C-1.08564e-06 7.16345 7.16344 3.50157e-06 16 3.11532e-06ZM16 29.3159C23.3542 29.3159 29.3159 23.3542 29.3159 16C29.3159 8.64584 23.3542 2.68412 16 2.68412C8.64584 2.68412 2.68412 8.64584 2.68412 16C2.68412 23.3542 8.64584 29.3159 16 29.3159Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M14.0781 15.1839C14.0781 14.2208 14.8589 13.44 15.822 13.44H16.1743C17.1374 13.44 17.9181 14.2208 17.9181 15.1839V23.2161C17.9181 24.1792 17.1374 24.96 16.1743 24.96H15.822C14.8589 24.96 14.0781 24.1792 14.0781 23.2161V15.1839Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M14.0781 8.78385C14.0781 7.82073 14.8589 7.03998 15.822 7.03998H16.1743C17.1374 7.03998 17.9181 7.82073 17.9181 8.78385V9.77611C17.9181 10.7392 17.1374 11.52 16.1743 11.52H15.822C14.8589 11.52 14.0781 10.7392 14.0781 9.77611V8.78385Z'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}

export default InformationIcon;
